module.exports = __webpack_public_path__ + "img/rezando.0004d0dc.png";